import React from 'react';
import styled, { createGlobalStyle } from 'styled-components';
import Autocomplete from '@mui/material/Autocomplete';
import {
  TextField,
  FormControl,
  Popper,
  Icon,
  Chip,
  InputLabel,
} from '@mui/material';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes } from '@fortawesome/free-solid-svg-icons';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';

const GlobalStyle = createGlobalStyle`
  .MuiPaper-root {
    font-family: 'Whitney Book';
  }
`;
const StyledForm = styled(FormControl)`
  margin-top: 8px;

  &:focus-visible {
    outline: none;
  }

  .MuiInputBase-root {
    border-radius: 0;
    font-family: 'Whitney Book';
  }

  .MuiOutlinedInput-root {
    input[type='text'] {
      border: 0;
      margin-bottom: 8px;
      outline: none;
      padding-left: 10px;
      padding-top: 8px;
      &:focus {
        box-shadow: none;
        outline: none;
        border: 0;
      }
    }
  }

  &&&&& .MuiOutlinedInput-notchedOutline {
    border-color: #888888;
    border-radius: 0;
  }

  &&&&&&&&&& .Mui-error {
    .MuiOutlinedInput-notchedOutline {
      border-color: #bf1e2d;
    }
  }

  .MuiFormHelperText-root.Mui-error {
    color: #bf1e2d;
    font-family: Whitney Medium;
    font-size: 13px;
    margin-left: 0;
  }

  &&&&&&&&& .MuiAutocomplete-input {
    min-width: 5px;
  }

  .MuiAutocomplete-root .PrivateNotchedOutline-root-1 {
    bottom: 10px;
  }
  .MuiChip-root {
    color: #555555;
    background-color: #f1f1f1;
    border-radius: 0;
    display: grid;
    grid-template-columns: 1fr auto;
    font-family: 'Whitney Book';
    font-size: 14px;
  }
  .MuiChip-deleteIcon {
    &:hover {
      color: #be202e;
      background-color: rgba(190, 32, 46, 0.2);
    }
  }
  &&&&&& .MuiAutocomplete-input {
    margin: 0;
    padding: 0;
  }
  .delete-icon-box {
    padding: 4px 10px;
    margin: 0;
    &:hover {
      color: #be202e;
      border-radius: 0;
      background-color: rgba(190, 32, 46, 0.2);
      .svg-inline--fa.fa-xmark {
        color: #be202e;
      }
    }
    .svg-inline--fa.fa-xmark {
      color: #000000;
      width: 7px;
      &:hover {
        color: #be202e;
      }
    }
  }

  .helper-text {
    color: #555;
    font-size: 14px;
    margin-top: 0.25rem;
  }
`;
const StyledLabel = styled(InputLabel)`
  &&&&&& {
    color: #000;
    font-family: 'Whitney Medium';
    left: -12px;
    position: relative;
    top: -22px;
  }
`;

const DeleteIconBox = (props) => (
  <span {...props}>
    <FontAwesomeIcon icon={faTimes} size="sm" tabIndex="0" />
  </span>
);

export function Multiselect({
  id,
  name,
  value,
  errorMessage,
  label,
  error,
  required,
  options,
  helperText,
  onBlur = () => {},
  onChange = () => {},
  onMouseOut = () => {},
}) {
  return (
    <React.Fragment>
      <GlobalStyle />
      <StyledForm variant="outlined">
        <StyledLabel htmlFor={id}>
          {label}
          {!required && ' (optional)'}
        </StyledLabel>
        <Autocomplete
          popupIcon={<ExpandMoreIcon />}
          multiple
          options={options}
          id={id}
          name={name}
          onBlur={onBlur}
          onMouseOut={() => onMouseOut()}
          value={value || []}
          onChange={(_event, selectedVals) =>
            onChange(
              name,
              selectedVals.map((val) => val.value || val)
            )
          }
          label={label}
          renderTags={(value, getTagProps) =>
            value.map((v, index) => (
              <Chip
                label={
                  options.filter((option) => option.value == v)[0] &&
                  options.filter((option) => option.value == v)[0].label
                }
                deleteIcon={<DeleteIconBox className="delete-icon-box" />}
                {...getTagProps({ index })}
              />
            ))
          }
          getOptionLabel={(option) => option.label}
          isOptionEqualToValue={(option, value) => option.value === value}
          filterSelectedOptions
          renderInput={(params) => (
            <TextField
              {...params}
              variant="outlined"
              label=""
              name={name}
              error={error}
              helperText={errorMessage}
              inputProps={{ ...params.inputProps }}
            />
          )}
        />
        {helperText && <p className="helper-text">{helperText}</p>}
      </StyledForm>
    </React.Fragment>
  );
}
